import React, { useEffect, useState } from "react";
import { BsArrowUpShort } from "react-icons/bs";
import "react-vertical-timeline-component/style.min.css";
import "react-image-lightbox/style.css";
import bgMain from "../../assets/2027_img/1.png";
import imgTitle from "../../assets/2027_img/2.png";
import QR from "../../assets/2027_img/QR.jpg";
import footerBg from "../../assets/img/footer_bg.jpg";
import treedbook from "../../assets/2027_img/treedbook.jpg"
import Map from "./Map";
import { Link, useLocation } from "react-router-dom";
import { Button, Select, Card } from "antd";
import { useNavigate } from "react-router-dom";
import AttendMap from "./Map/attendMap";
import Schedule from "./2026_schedule";
import PDFsection from "./Schedule";

export default function Home27() {
  const navigate = useNavigate();
  const [value, setValue] = useState("/");
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    if (["/","/2026", "/2025", "/2024", "/2022"].includes(currentPath)) {
      setValue(currentPath);
    }
  }, [location]);

  const handleChange = (value) => {
    if (value) {
      setValue(value);
      navigate(value);
    }
  };

  useEffect(() => {
    /**
     * Easy selector helper function
     */
    const select = (el, all = false) => {
      el = el.trim();
      if (all) {
        return [...document.querySelectorAll(el)];
      } else {
        return document.querySelector(el);
      }
    };

    /**
     * Easy event listener function
     */
    const on = (type, el, listener, all = false) => {
      let selectEl = select(el, all);
      if (selectEl) {
        if (all) {
          selectEl.forEach((e) => e.addEventListener(type, listener));
        } else {
          selectEl.addEventListener(type, listener);
        }
      }
    };

    /**
     * Easy on scroll event listener
     */
    const onscroll = (el, listener) => {
      el.addEventListener("scroll", listener);
    };

    /**
     * Navbar links active state on scroll
     */
    let navbarlinks = select("#navbar .scrollto", true);
    const navbarlinksActive = () => {
      let position = window.scrollY + 200;
      navbarlinks.forEach((navbarlink) => {
        if (!navbarlink.hash) return;
        let section = select(navbarlink.hash);
        if (!section) return;
        if (
          position >= section.offsetTop &&
          position <= section.offsetTop + section.offsetHeight
        ) {
          navbarlink.classList.add("active");
        } else {
          navbarlink.classList.remove("active");
        }
      });
    };
    window.addEventListener("load", navbarlinksActive);
    onscroll(document, navbarlinksActive);

    /**
     * Scrolls to an element with header offset
     */
    const scrollto = (el) => {
      let header = select("#header");
      let offset = header.offsetHeight;

      if (!header.classList.contains("header-scrolled")) {
        offset -= 20;
      }

      let elementPos = select(el).offsetTop;
      window.scrollTo({
        top: elementPos - offset,
        behavior: "smooth",
      });
    };

    /**
     * Toggle .header-scrolled class to #header when page is scrolled
     */
    let selectHeader = select("#header");
    if (selectHeader) {
      const headerScrolled = () => {
        if (window.scrollY > 100) {
          selectHeader.classList.add("header-scrolled");
        } else {
          selectHeader.classList.remove("header-scrolled");
        }
      };
      window.addEventListener("load", headerScrolled);
      onscroll(document, headerScrolled);
    }

    /**
     * Back to top button
     */
    let backtotop = select(".back-to-top");
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add("active");
        } else {
          backtotop.classList.remove("active");
        }
      };
      window.addEventListener("load", toggleBacktotop);
      onscroll(document, toggleBacktotop);
    }

    /**
     * Mobile nav toggle
     */
    on("click", ".mobile-nav-toggle", function (e) {
      select("#navbar").classList.toggle("navbar-mobile");
      this.classList.toggle("bi-list");
      this.classList.toggle("bi-x");
    });

    /**
     * Mobile nav dropdowns activate
     */
    on(
      "click",
      ".navbar .dropdown > a",
      function (e) {
        if (select("#navbar").classList.contains("navbar-mobile")) {
          e.preventDefault();
          this.nextElementSibling.classList.toggle("dropdown-active");
        }
      },
      true
    );

    /**
     * Scrool with ofset on links with a class name .scrollto
     */
    on(
      "click",
      ".scrollto",
      function (e) {
        if (select(this.hash)) {
          e.preventDefault();

          let navbar = select("#navbar");
          if (navbar.classList.contains("navbar-mobile")) {
            navbar.classList.remove("navbar-mobile");
            let navbarToggle = select(".mobile-nav-toggle");
            navbarToggle.classList.toggle("bi-list");
            navbarToggle.classList.toggle("bi-x");
          }
          scrollto(this.hash);
        }
      },
      true
    );

    window.addEventListener("load", () => {
      if (window.location.hash) {
        if (select(window.location.hash)) {
          scrollto(window.location.hash);
        }
      }
    });

    let preloader = select("#preloader");
    if (preloader) {
      window.addEventListener("load", () => {
        preloader.remove();
      });
    }
  }, []);

  return (
    <div>
      <header
        id="header"
        class="fixed-top d-flex align-items-center header-transparent"
      >
        <div class="container d-flex align-items-center justify-content-between">
          <div class="logo">
            <a href="/">
              <img
                src={"https://cdn.esis.edu.mn/logo/bshuy1.png"}
                alt=""
                class="img-fluid"
              />
            </a>
          </div>
          <nav id="navbar" class="navbar">
            <ul>
              <li>
                <a class="nav-link scrollto active" href="#hero">
                  Эхлэл
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#features">
                  Хэлэлцүүлэг
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#attend">
                  Олон нийт
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#schedule">
                  Хөрөнгө оруулалт
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#footer">
                  Холбоо барих
                </a>
              </li>
            </ul>
            <i class="bi bi-list mobile-nav-toggle"></i>
          </nav>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginRight: 5 }}>
          <Select
            value={value}
            style={{ width: 120 }}
            onChange={handleChange}
            options={[
              { value: "/", label: "2027 TT" },
              { value: "/2026", label: "2026 TT" },
              { value: "/2025", label: "2025 TT" },
              { value: "/2024", label: "2024" },
              { value: "/2022", label: "2022" },
            ]}
          />
        </div>
      </header>

      <section
        id="hero"
        style={{
          backgroundImage: `url(${bgMain})`,
          backgroundPosition: "center",
          objectFit: "fill",
        }}
      >
        <div class="hero-title-container">
          <div
            className="w-100 d-flex justify-content-center"
            style={{ direction: "row" }}
          >
            <img src={imgTitle} className="img-title"></img>
          </div>
        </div>

        <svg
          class="hero-waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28 "
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="wave-path"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="wave1">
            <use
              xlinkHref="#wave-path"
              x="50"
              y="3"
              fill="rgba(255,255,255, .1)"
            />
          </g>
          <g class="wave2">
            <use
              xlinkHref="#wave-path"
              x="50"
              y="0"
              fill="rgba(255,255,255, .2)"
            />
          </g>
          <g class="wave3">
            <use xlinkHref="#wave-path" x="50" y="9" fill="#fff" />
          </g>
        </svg>
      </section>
      <section id="features">
        <div
          class="container"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div class="section-title" data-aos="fade-up">
            <h2>Хэлэлцүүлэг</h2>
            <p>
              Олон нийтийн хэлэлцүүлэг 2026 оны 08 сарын 04-ний өдрийн 14:00 цагт ШУТИС-ын Номын сангийн 6 давхарын хурлын зааланд явагдана.
            </p>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div class="flex-parent">
              <div class="flex-item">
                <LinkImageCard
                  imageSrc={treedbook}
                  link="https://online.fliphtml5.com/viafg/flxj/"
                  title="Төсвийн төсөл 2027"
                />
                {/* <video
                  autoPlay
                  muted
                  controls
                  preload="auto"
                  playsInline
                  width="100%"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  <source
                    src="https://cdn.esis.edu.mn/econtent/ebudget/28451.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
              </div>

              <div class="flex-item">
                <p style={{ fontSize: "18px" }}>
                  Боловсролын салбарын урсгал зардал, хөрөнгө оруулалтын төсөл
                  арга хэмжээний 2027 оны төсвийн төсөлд иргэн та саналаа өгнө
                  үү.
                </p>

                <div>
                  <p style={{ fontSize: "18px" }}>
                    <Button
                      type="primary"
                      size="large"
                      target="_blank"
                      rel="noreferrer"
                      href="https://forms.gle/Ew3qgeRXebkEGomq8"
                    >
                      Хөрөнгө оруулалтын санал өгөх
                    </Button>
                  </p>
                  <p style={{ fontSize: "18px" }}>
                    <Button
                      type="primary"
                      target="_blank"
                      size="large"
                      rel="noreferrer"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSca_hxFfxQs2M5tMmSPPwdcU-CQcck0Cu46rrPELYcF8blUAQ/viewform"
                    >
                      Урсгал зардлын санал өгөх
                    </Button>
                  </p>
                </div>

                {/* <p style={{ fontSize: "16px", color: "#cfa600" }}>
                  Cанал асуулга 2026 оны 08 дугаар сарын 14-ний 17:30-д дуусна.
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div
          class="container"
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div class="section-title" data-aos="fade-up">
            <h2>ТӨСВИЙН ТӨСӨЛ</h2>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              style={{ height: "170px", width: "170px", marginRight: "1cm" }}
              src={QR}
              // className="img-title"
            ></img>
            <div>
              <h4 style={{ color: "#165380" }}>
                QR кодыг уншуулан <b>Төсвийн төсөл 2027</b> хэлэлцүүлэгт
                бүртгүүлнэ үү.
              </h4>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSe-X9T1Ss8L-krC1y0n0UBXfyKgfpJvrIDTdI5fF7xrcrmBdQ/viewform"
                target="_blank"
                rel="noreferrer"
              >
                Холбоосоор бүртгүүлэх
              </a>
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section id="attend">
          <AttendMap />
        </section>
        <section id="schedule">
          <Map />
          {/* <PDFsection /> */}
        </section>
        <section>
          <Schedule />
        </section>
      </main>
      <footer id="footer" style={{ backgroundImage: `url(${footerBg})` }}>
        <div class="footer-top">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-6 footer-newsletter">
                <img
                  src={"https://cdn.esis.edu.mn/logo/bshuy1.png"}
                  class="testimonial-img"
                  alt=""
                />
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="footer-info">
                  <h3>ХОЛБОО БАРИХ</h3>
                  <p class="pb-3">
                    Улаанбаатар хот, Сүхбаатар дүүрэг, Бага тойруу-44, Засгийн
                    газрын III байр
                  </p>
                  <p>
                    <strong>Phone:</strong> <a href="tel:+976 11-11"> 11-11</a>
                    <br></br>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:letter@mecs.gov.mn">letter@mecs.gov.mn</a>
                    <br></br>
                  </p>
                  <div class="social-links mt-3">
                    <a
                      href="https://www.facebook.com/MinistryofEdu/"
                      class="facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="bx bxl-facebook"></i>
                    </a>
                    <a
                      href="https://twitter.com/MEDSMongolia"
                      class="twitter"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="bx bxl-twitter"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCIgop7wqZmSWHczm9wM1IPw/videos"
                      class="youtube"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="bx bxl-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="copyright text-uppercase">
            &copy; 2026 Боловсролын мэдээллийн технологийн төв
          </div>
        </div>
      </footer>
      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center"
      >
        <BsArrowUpShort size={28} color="#fff" />
      </a>
    </div>
  );
}


const LinkImageCard = ({
  imageSrc,
  link,
  title,
  alt = "image",
  maxWidth = 500,
}) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Card
      hoverable
      style={{ width: "fit-content", cursor: "pointer" }}
      styles={{ body: title ? undefined : { padding: 0 } }}
      cover={
        <img
          alt={alt}
          src={imageSrc}
          // maxWidth хүртэл жижигрэнэ, өндөр нь пропорциональ тохирно
          style={{ display: "block", width: "100%", maxWidth, height: "auto" }}
          onClick={handleClick}
        />
      }
      onClick={handleClick}
    >
      {title && <Card.Meta title={title} />}
    </Card>
  );
};